import { SeriesLineStyle } from '../../model/types';

export const LINE_STYLE_DASH_ARRAY: Record<
  SeriesLineStyle,
  string | undefined
> = {
  [SeriesLineStyle.solid]: undefined,
  [SeriesLineStyle.dashed]: '5 5',
  [SeriesLineStyle.dotted]: '1 4',
};

export const LINE_STYLE_PATTERN: Record<SeriesLineStyle, string> = {
  [SeriesLineStyle.solid]: '—',
  [SeriesLineStyle.dashed]: '- -',
  [SeriesLineStyle.dotted]: '· ·',
};

export const TABLEAU_20_COLORS = [
  '#4E79A7',
  '#F28E2B',
  '#59A14F',
  '#B6992D',
  '#499894',
  '#E15759',
  '#79706E',
  '#D37295',
  '#B07AA1',
  '#9D7660',
  '#A0CBE8',
  '#FFBE7D',
  '#8CD17D',
  '#F1CE63',
  '#86BCB6',
  '#FF9D9A',
  '#BAB0AC',
  '#FABFD2',
  '#D4A6C8',
  '#D7B5A6',
] as const;

export const GRID_STROKE_COLOR = '#E7E9EF';

export const Y_AXIS_TICK_COUNT = 8;
export const X_AXIS_MAX_TICK_COUNT = 12;
export const X_AXIS_TICK_FONT_SIZE = 14;

export const MIN_METRIC_LINE_WIDTH = 1.5;
export const MAX_METRIC_LINE_WIDTH = 5.5;
export const METRIC_WIDTH_BUCKET_COUNT = 5;

export const AREA_FILL_OPACITY = 0.15;
export const DIMMED_SERIES_OPACITY = 0.15;

export const SPLIT_CLASS_PREFIX = 'cw-split-';
export const CHART_SCOPE_CLASS_PREFIX = 'cw-chart-';

export const VALUE_LABEL_OFFSET = 8;
export const VALUE_LABEL_DOT_RADIUS = 3;
export const VALUE_LABEL_DIFF_OPACITY = 0.85;
export const VALUE_LABEL_BOLD_WEIGHT = 700;
export const VALUE_LABEL_REGULAR_WEIGHT = 400;

const DIFF_FONT_RATIO = 0.85;

export const getValueLabelDiffFontSize = (fontSize: number): number =>
  Math.round(fontSize * DIFF_FONT_RATIO);

export const VALUE_LABEL_ASCENT_RATIO = 0.8;
export const VALUE_LABEL_DESCENT_RATIO = 0.2;
export const VALUE_LABEL_BOX_PADDING = 2;
export const SEGMENT_CLEARANCE = 3;

export const BAR_GAP = 4;
export const BAR_CATEGORY_GAP_PERCENT = 10;
